/* eslint-disable camelcase */
import { deleteIDBValue, getIDBValue } from "common/utils/storage/idb";
import isMSLegacy from "common/utils/is-ms-legacy";
import {
  getRelatedStorageItem,
  removeRelatedStorageItem,
} from "common/utils/storage/legacy-storage";
import { getLocalStorageItem } from "common/utils/storage/local-storage";

import {
  ASSUMPTIONS_STORE,
  CURRENT_BUDGET,
  TEMPLATES_STORE,
} from "features/budget/budget.constants";
import {
  clearBudgetRelatedValues,
  getBudgetRelatedValues,
  getStepData,
  LEGACY_clearBudgetRelatedValues,
  LEGACY_getBudgetRelatedValues,
  LEGACY_getStepData,
  LEGACY_saveBudgetRelatedValue,
  LEGACY_saveStepData,
  saveBudgetRelatedValue,
  saveStepData,
} from "features/budget/wizard/state/wizard.storage";
import { ALL_ACCOUNTS_NAME } from "features/budget/templates/state/template.constants";

const STEP = 4;

export function sortAllAccountsFirst(a) {
  if (a.name === ALL_ACCOUNTS_NAME) {
    return -1;
  }
  return 0;
}

export async function saveTemplateAssignments(assignmentsObj) {
  if (isMSLegacy() === true) {
    LEGACY_saveStepData(STEP, assignmentsObj);
  } else {
    await saveStepData(STEP, assignmentsObj);
  }
}

export async function getTemplateAssignments() {
  let templateAssignments;
  if (isMSLegacy() === true) {
    templateAssignments = LEGACY_getStepData(STEP);
  } else {
    templateAssignments = await getStepData(STEP);
  }
  return templateAssignments;
}

export async function clearTemplateAssignments() {
  await saveTemplateAssignments(undefined);
}

export async function getTemplate(id) {
  let template;

  if (isMSLegacy() === true) {
    const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);
    template = getRelatedStorageItem(currentBudgetId, TEMPLATES_STORE, id);
  } else {
    template = await getIDBValue(TEMPLATES_STORE, id);
  }
  return template;
}

export async function removeTemplate(id) {
  if (isMSLegacy() === true) {
    const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);
    removeRelatedStorageItem(currentBudgetId, TEMPLATES_STORE, id);
  } else {
    await deleteIDBValue(TEMPLATES_STORE, id);
  }
}

export async function saveTemplate(id, data) {
  if (isMSLegacy() === true) {
    LEGACY_saveBudgetRelatedValue(TEMPLATES_STORE, id, data);
  } else {
    await saveBudgetRelatedValue(TEMPLATES_STORE, id, data);
  }
}

export async function getTemplates(allAccountsFirst = false) {
  let result;

  if (isMSLegacy() === true) {
    result = LEGACY_getBudgetRelatedValues(TEMPLATES_STORE);
  } else {
    result = await getBudgetRelatedValues(TEMPLATES_STORE);
  }

  if (allAccountsFirst === true) {
    result.sort(sortAllAccountsFirst);
  }
  return result;
}

export async function clearTemplates() {
  if (isMSLegacy() === true) {
    LEGACY_clearBudgetRelatedValues(TEMPLATES_STORE);
  } else {
    await clearBudgetRelatedValues(TEMPLATES_STORE);
  }
}

export async function saveScenarioLevelAssumptions(scenarioId, data) {
  if (isMSLegacy() === true) {
    LEGACY_saveBudgetRelatedValue(ASSUMPTIONS_STORE, scenarioId, data);
  } else {
    await saveBudgetRelatedValue(ASSUMPTIONS_STORE, scenarioId, data);
  }
}

export async function getScenarioLevelAssumptions(scenarioId) {
  let assumptions;

  if (isMSLegacy() === true) {
    [assumptions] = LEGACY_getBudgetRelatedValues(ASSUMPTIONS_STORE);
  } else {
    assumptions = await getIDBValue(ASSUMPTIONS_STORE, scenarioId);
  }
  return assumptions;
}

export async function clearScenarioLevelAssumptions(scenarioId) {
  if (isMSLegacy() === true) {
    LEGACY_clearBudgetRelatedValues(ASSUMPTIONS_STORE);
  } else {
    await deleteIDBValue(ASSUMPTIONS_STORE, scenarioId);
  }
}

export async function saveTemplatesList(templateList) {
  const asyncOperations = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const template of templateList) {
    asyncOperations.push(saveTemplate(template.id, template));
  }
  await Promise.all(asyncOperations);
}
